import { useState } from "react";
import { Download, Menu, X } from "lucide-react";
import { API, BRAND } from "@/content";

const LINKS = [
  ["About", "about"],
  ["What We Do", "what-we-do"],
  ["Bali 2026", "retreat"],
  ["Our Work", "our-work"],
  ["Contact", "contact"],
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-nav"
      className="fixed top-0 inset-x-0 z-40 backdrop-blur-md bg-[#12281D]/85 border-b border-[#D4AF37]/20"
    >
      <div className="mx-auto max-w-6xl px-5 h-16 flex items-center justify-between">
        <a href="#top" data-testid="nav-brand-link" className="flex items-baseline gap-2.5">
          <span className="font-script text-2xl text-[#D4AF37] leading-none">S &amp; A</span>
          <span className="hidden sm:inline font-serif text-sm tracking-wide text-[#FBF9F1]/90">
            {BRAND}
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-7">
          {LINKS.map(([label, id]) => (
            <a
              key={id}
              data-testid={`nav-link-${id}`}
              href={`#${id}`}
              className="text-[11px] uppercase tracking-[0.22em] text-[#FBF9F1]/70 hover:text-[#D4AF37] transition-colors duration-300"
            >
              {label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            data-testid="nav-download-pdf-button"
            href={`${API}/media-kit.pdf`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full border border-[#D4AF37]/50 px-4 py-2 text-xs font-semibold text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#1B3B2B] transition-[background-color,color] duration-300"
          >
            <Download size={14} />
            <span className="hidden sm:inline">Media Kit PDF</span>
            <span className="sm:hidden">PDF</span>
          </a>
          <button
            data-testid="nav-mobile-menu-button"
            aria-label="Toggle menu"
            onClick={() => setOpen(!open)}
            className="md:hidden text-[#FBF9F1] p-1"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden border-t border-[#D4AF37]/15 bg-[#12281D]/95 px-5 py-5 flex flex-col gap-4"
        >
          {LINKS.map(([label, id]) => (
            <a
              key={id}
              data-testid={`nav-mobile-link-${id}`}
              href={`#${id}`}
              onClick={() => setOpen(false)}
              className="text-sm uppercase tracking-[0.2em] text-[#FBF9F1]/80 hover:text-[#D4AF37] transition-colors"
            >
              {label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}
